$(function() {
    var h = $(window).height();
    //$('#js-loader').height(h).css('display','block');

    var w = $(window).width();
    var st;

    console.log('h:'+ h)
    console.log('w:'+ w)

    if(w > 600) {
        st = 'top 63px'
    } else {
        st = 'top 48px;'
    }
    if(w < 900) {
        $('.fv').height(h);
    }  

    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
        console.log('sp')

        //MVのスクロール処理
        gsap.utils.toArray("#fv").forEach(section => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top",
                    // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                    end: () => "+=" + section.offsetHeight,
                    scrub: true,
                    pin: true,
                    anticipatePin: 1
                },
                defaults: {ease: "none"}
            });
            tl.fromTo(section.querySelector("#fv-bg"), {'transform': 'scale(8)'}, {'transform': 'scale(1)'})
                .fromTo(section.querySelector(".fv__txt"), {'opacity': "1"}, {'opacity': "0"})
            // .set('.about .about__txt', {className:"+=about__txt view-about is-show"});
            // .fromTo(document, {duration: 2, scrollTo: '#about'});
        });

        var src = $(window).scrollTop();
        $(window).scroll(function () {
            var scr = $(window).scrollTop();
            if(scr > $(window).height() * 2 + 160) {
                $('#fv-bg').addClass('wh');
            } else {
                $('#fv-bg').removeClass('wh');
            }
        })

    } else {

        gsap.utils.toArray("#fv").forEach(section => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top",
                    // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                    end: () => "+=" + section.offsetHeight,
                    scrub: true,
                    pin: true,
                    anticipatePin: 1
                },
                defaults: {ease: "none"}
            });
            tl.fromTo(section.querySelector("#fv-bg"), {'transform': 'scale(8)'}, {'transform': 'scale(1)'})
                .fromTo(section.querySelector(".fv__txt"), {'opacity': "1"}, {'opacity': "0"})
            // .set('.about .about__txt', {className:"+=about__txt view-about is-show"});
            // .fromTo(document, {duration: 2, scrollTo: '#about'});
        });

    }




    gsap.utils.toArray("#js-design").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: st,
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                // end: () => "+=" + section.offsetWidth,
                scrub: true,
                pin: true,
                anticipatePin: 1
            },
            defaults: {ease: "none"}
        });
        tl.fromTo(section.querySelector("#design01"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design02"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design03"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design04"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design05"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design06"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design07"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design08"), { height: "calc(100vh - 53px)"}, {height: 0})
            .fromTo(section.querySelector("#design09"), { height: "calc(100vh - 53px)"}, {height: 0})
        // .fromTo(section.querySelector("#design03"), { height: "100%"}, {height: "100%"})
    });


    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {

        $('.fv').height(h);

    }else {

        $(window).on('load',function () {
            //Only Desktop
            // gsap.utils.toArray(".c-area").forEach(section => {
            //     let tl = gsap.timeline({
            //         scrollTrigger: {
            //             trigger: section,
            //             start: "center center",
            //             scrub: true,
            //             pin: true,
            //             anticipatePin: 1,
            //         },
            //         defaults: {ease: "none"}
            //     });
            //     tl.to(section, function () {
            //     })
            // });


            gsap.utils.toArray("#safety_lead").forEach(section => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "center center",
                        // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                        // end: () => "+=" + section.offsetWidth,
                        scrub: true,
                        pin: true,
                        anticipatePin: 1,
                    },
                    defaults: {ease: "none"}
                });
                // animate the container one way...
                tl.fromTo(section.querySelectorAll("#safety_en, #safety_ja"), { opacity: 0},{ opacity: 1})
                // ...and the image the opposite way (at the same time)
            });

        });

        ScrollReveal().reveal('.view', {
            duration: 2000,
            opacity: 1,
            viewFactor: 0.6,
            easing: 'ease',
            beforeReveal: function (el){
                el.classList.add('is-show');
            }
        });
    }

    const offset_a = $('.about').offset().top;
    $(window).scroll(function () {
        if($(window).scrollTop() >= offset_a - $(window).height() + 400 ) {
            $('.org_header').addClass('is_active');
            $('.view-about').addClass('is-show');
            $('#nav_menu_sp').addClass('is_active');
        } else {
            $('.org_header').removeClass('is_active');
            $('#nav_menu_sp').removeClass('is_active');
        }
    });

    setTimeout(function () {
        $('.fv__txt').addClass('is-show');
    }, 1200);

    var l_scr = $(window).scrollTop();

    if(l_scr < 100) {
        $('.loading').fadeIn(1000);
    } else {
        $('.loading').hide();
    }
    var f01 = $('#feature01'),
        // f02 = $('#feature02'),
        f03 = $('#factory'),
        f04 = $('#w-area'),
        f05 = $('#wt-area'),
        scr = $(window).scrollTop();

    var v_st = false;
    var t_st = false;
    var h_st = false;
    $(window).scroll(function () {
        scr = $(window).scrollTop();
        if(scr < 100) {
            $('.loading').fadeIn(1000);
        } else {
            $('.loading').fadeOut(1000);
        }


        if(scr >= $('#about').offset().top - 400 ) {
            $('#about .fadein_trg').addClass('is-show');
        }

        if (f04.offset().top <= scr + $(window).height()) {
            $('.w-view').css({'transform': 'translate(0, 0)', 'opacity':1 });
            $('.w-area__txt--main').css({'margin-top': 0 });
            setTimeout(function () {
                $('.w-view-after').css({'transform': 'translate(0, 0)', 'opacity':1 });
            },300)
        }
        if (f05.offset().top - 300 <= scr + $(window).height()) {
            $('.material .view-ttl').addClass('is-show')
            $('.material .fadein_trg').addClass('is-show')
        }

        if($(window).width() < 901) {
            $('.view-ttl').each(function(){
                var elemPos = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > elemPos - windowHeight -80){
                    $(this).addClass('is-show');
                }
            });
            $('.fadein_trg').each(function(){
                var elemPos = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > elemPos - windowHeight -80){
                    $(this).addClass('is-show');
                }
            });
        }

        $('.fadein, .fadein_right').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight -80){
                $(this).addClass('is-show');
            }
        });

    })
})



$(window).on('load',function () {
    /*
    $('#js-loader').delay(900).fadeOut(800);
    $('#loader').delay(600).fadeOut(300);
    */
    $("#tw-container").twentytwenty({
        default_offset_pct: .72,
    })
    $("#tw-container-sp").twentytwenty({
        default_offset_pct: .5,
    })
})
